import IntroPage from './IntroPage';

export default IntroPage;


// WEBPACK FOOTER //
// /src/components/intro/pages/introPage/index.js